'use strict';

/* global yith_wcaf */

import { $ } from '../../../src/globals.js';
import YITH_WCAF_Ajax from '../../../src/modules/ajax.js';

export default class YITH_WCAF_Admin_Table {
	// context
	$context = null;

	// table
	$table = null;

	// args
	args = null;

	constructor( $context, args ) {
		if ( ! $context.length ) {
			return;
		}

		let $table = $( 'table.wp-list-table', $context );

		if ( ! $table.length ) {
			$table = $( '.no-items-found', $context );
		}

		if ( ! $table.length ) {
			return;
		}

		this.$context = $context;
		this.$table = $table;
		this.args = $.extend(
			{
				action_suffix: '',
				nonce_suffix: '',
			},
			args || {}
		);

		this.init();
	}

	init() {}

	doButtonAction( action, $button, onSuccess ) {
		const $row = $button.closest( 'tr' );

		if ( ! $row.length ) {
			return;
		}

		let data = this.args?.data;

		if ( 'function' === typeof data ) {
			data = data.call( this, $row );
		}

		this.doAjax(
			`${ action }${ this.args?.action_suffix || '' }`,
			`${ action }${ this.args?.nonce_suffix || '' }`,
			data,
			( result ) => {
				if ( 'function' === typeof onSuccess ) {
					onSuccess( $row, result );
				}

				if ( result?.template ) {
					this.replaceTable( result.template );
				}
			}
		);
	}

	doAjax( action, security, data, onSuccess ) {
		return YITH_WCAF_Ajax.post
			.call( this.$context, action, security, data )
			.done( ( answerData ) => {
				if ( 'function' === typeof onSuccess && answerData?.success ) {
					onSuccess( answerData?.data );
				}
			} );
	}

	replaceTable( newTable ) {
		const $newTable = $( newTable ).find( 'table' );

		if ( ! $newTable.length ) {
			return;
		}

		this.$table.replaceWith( $newTable );
		this.$table = $newTable;
	}
}
